export var BaseUrl:string = 'https://admin.www.userinsights.kimclark.com/api/v2.0/';
export var ApiGatewayUrl:string = "https://api.userinsights.kimclark.com/oauth2/authorization/okta"

